import { render, staticRenderFns } from "./CategoriaHeader.vue?vue&type=template&id=0501e9f0"
import script from "./CategoriaHeader.vue?vue&type=script&lang=js"
export * from "./CategoriaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports